import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import MyBusinessGrid from '../../molecules/Desktop/MyBusinessGrid';
import BusinessTabs from '../../molecules/Desktop/BusinessTabs';
import { BusinessStageType, BusinessTabType } from '../../data/types';
import Recommendations from './Recommendations';


type MyBusinessProps = {}

const MyBusiness: React.FC<MyBusinessProps> = () => {
    const [searchParams] = useSearchParams();
    const [width, setWidth] = useState<number>(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const isMobile = width < 1024;

    const stage = searchParams.get('stage');
    const [businessStage, setBusinessStage] = useState<BusinessStageType>(stage as BusinessStageType || 'dream');
    const startTab = {
        dream: 'business', 
        build: 'recommendations', 
        scale: 'menu'
    } as BusinessTabType
    

    return (
        <div className={`flex flex-col min-h-screen bg-white ${isMobile ? 'pb-16' : ''}`}>
            <BusinessTabs startTab={startTab} businessStage={businessStage} setBusinessStage={setBusinessStage} />
                
            <div className={`flex-1 ${isMobile ? 'px-4' : 'px-6'}`}>
                <div className={`max-w-7xl mx-auto w-full ${isMobile ? 'py-4' : 'py-8'}`}>
                    {
                        businessStage === 'dream' ? (
                            <MyBusinessGrid />
                        ) : (
                            businessStage === 'build' ? (
                                <Recommendations />
                            ) : (
                                <></>
                            )
                        )
                    }
                </div>
            </div>
        </div>
    );
}

export default MyBusiness;




